let constants = {}

export const setConstants = (set_constants) => {
  constants = set_constants
}

export const getConstant = (constant_name) => {
  // console.log("getconstant", constant_name, constants);
  return constants[constant_name];
}